var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('span',[(_vm.params.data.from_user.picture)?_c('img',{staticClass:"person-img rounded-full",attrs:{"src":_vm.params.data.from_user.picture}}):_c('img',{staticClass:"person-img rounded-full",attrs:{"src":require("@/assets/images/pages/user-circle-solid.svg")}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }